import IconParticipant from '@/assets/svgs/icon-building.svg';
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import iconSearch from '@/assets/svgs/icon-search.svg';
import { ReactComponent as InfoIcon } from '@/assets/svgs/infoCircle.svg';
import { ReactComponent as DeleteIcon } from '@/assets/svgs/trashIcon.svg';
import Button from '@/components/Button';
import useConfig from '@/hooks/use-config';
import useModal from '@/hooks/use-modal/index';
import { useNavigate, useParams } from '@/lib/router-dom';
import api from '@/services/api/messages.js';
import "@/translations/i18n";
import addFormats from "@/utils/custom-ajv-formats";
import rem from '@/utils/rem.js';
import Ajv from "ajv";
import { sortBy } from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import { ReactComponent as IconConfigure } from '@/assets/svgs/icon-configure.svg';
const ajv = new Ajv({ allErrors: true });
addFormats(ajv);

const forwardingAllowedTypes = ["PULL", "RECEIVE"]


export const ParticipantWhohaveAccess = ({ itemData, modalParticipant, setModalParticipant }) => {

	function handleRemove(id) {
		const updatedItems = modalParticipant.filter(option => option.id !== id)

		setModalParticipant(updatedItems)
	}

	const list = sortBy(itemData, 'name')?.map((item) => {

		return (
			<div className='access-data-flex access-data__margin-top' key={item.id}>

				<div className='access-data__selected-participant-name access-data-flex'>
					{/* TODO Check for valid url and apply background image */}
					<span><div className="access-data__avatar" style={{ backgroundImage: `url(${item?.iconUrl ? item.iconUrl : IconParticipant})` }}></div></span>
					{item?.name}
				</div>

				<Button text="Remove" ghost submit={() => handleRemove(item?.id)} />
			</div>
		)
	})
	return (
		list.length > 0 ? <>{list}</> : <> </>
	)
}

export const SearchParticipantsList = ({ itemData, searchParticipant, modalParticipant, setSearchParticipantText, setModalParticipant, setFilterVisible }) => {
	function handleClick(item) {
		setFilterVisible(false)
		setSearchParticipantText("")

		setModalParticipant(prev => [...prev, item])
	}

	const list = sortBy(searchParticipant, 'name').filter(participant => {
		return !modalParticipant.find(modal => {
			return modal.id === participant.id
		})
	}).filter(item => item.id !== "MY_PITSTOP" || !modalParticipant.includes(item.id)).map((item) => {
		return (
			<div key={item.id}
				className="access-data__column__add__col link"
				role='button'
				onKeyDown={() => { }}
				tabIndex={0} // Add tabIndex attribute to make the element focusable
				onClick={() => handleClick(item)}
			>
				{/* TODO Check for valid url and apply background image */}
				<span><div className="access-data__avatar" style={{ backgroundImage: `url(${item?.iconUrl ? item.iconUrl : IconParticipant})` }}></div></span>
				<span className='access-data__selected-participant-name'>{item.name}</span>
			</div>

		)
	})

	return list.length > 0 ? <>{list}</> : (<div className="access-data__column__add__col access-data__column__add__col--no-hover">
		<span className='access-data__selected-participant-name'>No data found</span>
	</div>)

}

export function searchOnParticipants(search, participants, setSearchParticipant) {
	if (!participants) {
		return
	}

	const result = participants
		.filter(item => item.name.toLowerCase().includes(search.toLowerCase()));

	setSearchParticipant(result);
}


export async function handleRestricted(modalParticipant, type, messageId, setError, goTo, api, fetchOne, item) {
	const payload = {
		storedFor: modalParticipant && modalParticipant.length > 0 ? modalParticipant : null
	}

	if (type === "STORE") {
		const [error] = await api.patchMessageStoredFor(messageId, payload);

		if (error) {
			setError(error?.error?.message || "Failed to delete Pitstop Config");
		} else {
			return await fetchOne(messageId);
		}

	}

	if (forwardingAllowedTypes.includes(type)) {
		const [error, result] = await api.putMessageStoredFor(messageId, payload);

		if (error) {
			setError(error?.error?.message || "Failed to delete Pitstop Config");
		}

		return goTo(`/shared-data/transaction/${result.id}`, { currentItem: item });
	}
}

const InfoMessage = ({ children }) => (
	<>
		<span>
			<InfoIcon />
		</span>
		{children}
	</>
);

const StoredForItem = ({ storedItem, storedFor, setModalParticipant, showRestrictAccessModal }) => (
	<div className="data-table__table__body__row-access" key={storedItem.id}>
		<div className="data-table__table__body__content--text data-table__table__body__content--heavy">
			{storedItem?.name}
		</div>
		<div className="data-table__table__body__content--text data-table__table__body__content--end-access">
			<span className="data-table__table__body__content__action link"
				role='button'
				tabIndex={0}
				onKeyDown={() => { }}
				onClick={() => {
					setModalParticipant(storedFor)
					showRestrictAccessModal()
				}}
			>
				<DeleteIcon />
			</span>
		</div>
	</div>
);

export const AccessRestrictionCard = ({ currentItem, fetchOne, storedFor, participants, setError }) => {

	const { t } = useTranslation();
	const { goTo } = useNavigate();
	const { messageId } = useParams()
	const { type } = currentItem || {};

	const [searchParticipant, setSearchParticipant] = useState([])

	const [filterVisible, setFilterVisible] = useState()

	const [modalParticipant, setModalParticipant] = useState([])
	const [searchParticipantText, setSearchParticipantText] = useState()

	const [accessData, setAccessData] = useState('allOrg');
	const { provideItems } = useConfig()

	useEffect(() => {
		fetchOne(messageId);
	}, [messageId]);


	function goToStoredMessage(id) {
		return goTo(`/shared-data/transaction/${id}`, { currentItem: currentItem })
	}

	const { visible: restrictAccessModal, show: showRestrictAccessModal, hide: hideRestrictAccessModal } = useModal()
	const { visible: accessSettingModal, show: showAccessSettingModal, hide: hideAccessSettingModal } = useModal()

	/*=================================================
		Data Restricitons
	/================================================*/
	const storedForList = storedFor && storedFor.length > 0 ? sortBy(storedFor, 'name').map((storedItem, index) => (
		<StoredForItem key={index} storedItem={storedItem} storedFor={storedFor} setModalParticipant={setModalParticipant} showRestrictAccessModal={showRestrictAccessModal} />
	)) :
		<div className="access-card__empty--center">
			{
				type === "STORE" ? (
					<InfoMessage>
						All organisations allowed to consume this data element can retrieve this data element from your pitstop.
					</InfoMessage>
				) : forwardingAllowedTypes.includes(type) ? (
					<InfoMessage>
						This data transaction cannot be retrieved by other organisations.
					</InfoMessage>
				) : forwardingAllowedTypes.includes(type) && provideItems?.some(dataElement => dataElement.id === currentItem.dataElement.id) && currentItem.isShared === true ? (
					<InfoMessage>
						Sharing has been enabled for this transaction. Please view the shared transaction for details.
					</InfoMessage>
				) : null
			}
		</div>


	const handleAccessButtonClick = () => {
		if (type === "STORE" || forwardingAllowedTypes.includes(type)) {
			if (type !== "STORE" && provideItems?.some(dataElement => dataElement.id === currentItem.dataElement.id) && currentItem.isShared === true) {
				return goToStoredMessage(currentItem.refMessageId);
			} else {
				return showAccessSettingModal();
			}
		} else {
			return showRestrictAccessModal();
		}
	}

	return (
		<>
			{

				<div className="data-table__content">
					<div className="data-table__content__cols">
						<div className="data-table__content__col">
							<div className="data-table__table-access access-table" data-testid="access-restriction-table">
								<div className="data-table__table__head">
									<div className="data-table__table__head__row-access">
										<div className="">
											<div className="data-table__table__head__heading">
												Access
											</div>
										</div>
										<div className="data-table__table__head__row__right-access">
											{
												storedFor?.length > 0 ? (
													<div className='data-table__table_access_button'
														role='button'
														tabIndex={0}
														onKeyDown={() => { }}
														onClick={() => {
															setModalParticipant(storedFor)
															showRestrictAccessModal()
														}}>
														Change settings
													</div>

												) :
													(
														<div className='data-table__table_access_button'
															role='button'
															onKeyDown={() => { }}

															tabIndex={0}
															onClick={handleAccessButtonClick}
														>
															{type !== "STORE" && forwardingAllowedTypes.includes(type) && provideItems?.some(dataElement => dataElement.id === currentItem.dataElement.id) && currentItem.isShared === true ? "View Transaction" : "Enable Sharing"}
														</div>
													)
											}
										</div>

									</div>
								</div>
								<div className="access-card-elements-container">
									{
										storedFor?.length > 0 && (
											<span className="data-table__table__head__heading--caption--neo">
												<span>
													<InfoIcon />
												</span>
												<p>

													Only the following organisations are allowed to <br /> retrieve this data from your pitstop.
												</p>
											</span>
										)
									}
									{storedForList}
								</div>
							</div>
						</div>
					</div>
				</div>

			}

			<Modal visible={restrictAccessModal } variant='medium' close={hideRestrictAccessModal}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className='card-configure__icon'>
											<IconConfigure />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Restricted Access
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className='access-data-input' >

								<input type="text"
									onChange={(e) => {
										setFilterVisible(true);
										searchOnParticipants(e.target.value, participants, setSearchParticipant)

										setSearchParticipantText(e.target.value)

										if (e.target.value === "") {
											setFilterVisible(false);
										}
									}}

									value={searchParticipantText}
									// onBlur={() => setFilterVisible(false)}
									placeholder='Add an Organisation'
									style={{ backgroundImage: `url(${iconSearch})` }} />

								{
									filterVisible && (

										<div className='access-data__popover-box'>
											{
												<SearchParticipantsList itemData={participants}
													searchParticipant={searchParticipant}
													setFilterVisible={setFilterVisible}
													modalParticipant={modalParticipant}
													setModalParticipant={setModalParticipant}
													setSearchParticipantText={setSearchParticipantText}
												/>
											}
										</div>

									)
								}
							</div>
							<div className='access-data-input__list'>
								<ParticipantWhohaveAccess itemData={modalParticipant} setModalParticipant={setModalParticipant} modalParticipant={modalParticipant} border="ghost" />
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>

							<span className='access-data--footer-text'>
								These organisations will be able to retrieve this data from your pitstop.
							</span>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>

							<Button text="Done"
								submit={() => {
									hideRestrictAccessModal();
									handleRestricted(modalParticipant, type, messageId, setError, goTo, api, fetchOne, currentItem)
								}} />

						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Modal visible={accessSettingModal} close={hideAccessSettingModal} variant='medium'>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className='card-configure__icon'>
											<IconConfigure />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Restricted Access
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className='data-element-content-wrap' >
								<span className="t--share-data-subheader">{t("chooseWhoYouWantToAccessData")}</span>

								<div className="download-transaction__row__right__radio access-data-restriction-margin-top ">
									<input type="radio" value="allOrg" name="accessData" id="allOrg" checked={accessData === "allOrg"}
										onClick={(e) => setAccessData(e.target.value)}
									/> <label className='label-for-access-data' htmlFor="allOrg">All eligible organisations (Default).</label>
								</div>

								<div className='sub-label-for-access-data'>Organisations allowed to consume this data from you will be able to retrieve this data</div>

								<div className="download-transaction__row__right__radio access-data-restriction-margin-top">
									<input type="radio" value="restricted" name="accessData" id="restricted" checked={accessData === "restricted"}
										onClick={(e) => setAccessData(e.target.value)}
									/> <label htmlFor="restricted">Restricted organisations only</label>
								</div>

								<div className='sub-label-for-access-data'>Organisations you specify will be able to retrieve this data</div>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<Button text="Done"
								submit={() => {
									if (accessData === "allOrg") {
										hideAccessSettingModal()
										handleRestricted(modalParticipant, type, messageId, setError, goTo, api, fetchOne, currentItem)
									}

									if (accessData === "restricted") {
										showRestrictAccessModal()
										hideAccessSettingModal()
									}
								}} />

						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
		</>
	)
};



AccessRestrictionCard.propTypes = {
	currentItem: PropTypes.object,
	fetchOne: PropTypes.func,
	storedFor: PropTypes.array,
	participants: PropTypes.array,
	setError: PropTypes.func
};

ParticipantWhohaveAccess.propTypes = {
	itemData: PropTypes.array,
	modalParticipant: PropTypes.array,
	setModalParticipant: PropTypes.func
};

SearchParticipantsList.propTypes = {
	itemData: PropTypes.array,
	searchParticipant: PropTypes.array,
	modalParticipant: PropTypes.array,
	setSearchParticipantText: PropTypes.func,
	setModalParticipant: PropTypes.func,
	setFilterVisible: PropTypes.func
};

InfoMessage.propTypes = {
	children: PropTypes.node
};

StoredForItem.propTypes = {
	storedItem: PropTypes.object,
	storedFor: PropTypes.array,
	setModalParticipant: PropTypes.func,
	showRestrictAccessModal: PropTypes.func
}
